"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.allConditions = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _TableInput = _interopRequireDefault(require("../TableInput"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _PickColumnForm = _interopRequireDefault(require("../PickColumnForm"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var numberFieldComponent = function numberFieldComponent(_ref) {
  var path = _ref.path;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: path,
    type: "number",
    className: "form-control",
    component: _TableInput["default"]
  });
};
var numberFieldValidate = function numberFieldValidate(value) {
  var errors = {};
  if (!value && value !== 0) {
    errors.value = 'Value is required';
  }
  return errors;
};
var stringFieldComponent = function stringFieldComponent(_ref2) {
  var path = _ref2.path;
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: path,
    className: "form-control",
    component: _TableInput["default"]
  });
};
var stringFieldValidate = function stringFieldValidate(value) {
  var errors = {};
  if (!value) {
    errors.value = 'Value is required';
  }
  return errors;
};
var allConditions = function () {
  var result = {
    number: [{
      value: 'eq',
      label: 'equals to',
      initialValue: 0,
      component: numberFieldComponent,
      validate: numberFieldValidate,
      getCondition: function getCondition(_ref3) {
        var field = _ref3.field,
          value = _ref3.value;
        return "eq: { field: \"".concat(field, "\" int: ").concat(value, " }");
      }
    }, {
      value: 'lt',
      label: 'lower than',
      initialValue: 0,
      component: numberFieldComponent,
      validate: numberFieldValidate,
      getCondition: function getCondition(_ref4) {
        var field = _ref4.field,
          value = _ref4.value;
        return "lt: { field: \"".concat(field, "\" int: ").concat(value, " }");
      }
    }, {
      value: 'lte',
      label: 'lower or equal to',
      initialValue: 0,
      component: numberFieldComponent,
      validate: numberFieldValidate,
      getCondition: function getCondition(_ref5) {
        var field = _ref5.field,
          value = _ref5.value;
        return "lte: { field: \"".concat(field, "\" int: ").concat(value, " }");
      }
    }, {
      value: 'gt',
      label: 'greater than',
      initialValue: 0,
      component: numberFieldComponent,
      validate: numberFieldValidate,
      getCondition: function getCondition(_ref6) {
        var field = _ref6.field,
          value = _ref6.value;
        return "gt: { field: \"".concat(field, "\" int: ").concat(value, " }");
      }
    }, {
      value: 'gte',
      label: 'greater or equal to',
      initialValue: 0,
      component: numberFieldComponent,
      validate: numberFieldValidate,
      getCondition: function getCondition(_ref7) {
        var field = _ref7.field,
          value = _ref7.value;
        return "gte: { field: \"".concat(field, "\" int: ").concat(value, " }");
      }
    }],
    string: [{
      value: 'contains',
      label: 'contains',
      initialValue: '',
      component: stringFieldComponent,
      validate: stringFieldValidate,
      getCondition: function getCondition(_ref8) {
        var field = _ref8.field,
          value = _ref8.value;
        return "contains: { field: \"".concat(field, "\" string: \"").concat(value, "\" }");
      }
    }, {
      value: 'notContains',
      label: 'not contains',
      initialValue: '',
      component: stringFieldComponent,
      validate: stringFieldValidate,
      getCondition: function getCondition(_ref9) {
        var field = _ref9.field,
          value = _ref9.value;
        return "notContains: { field: \"".concat(field, "\" string: \"").concat(value, "\" }");
      }
    }, {
      value: 'eq',
      label: 'equals to',
      initialValue: '',
      component: stringFieldComponent,
      validate: stringFieldValidate,
      getCondition: function getCondition(_ref10) {
        var field = _ref10.field,
          value = _ref10.value;
        return "eq: { field: \"".concat(field, "\" string: \"").concat(value, "\" }");
      }
    }],
    "boolean": [{
      value: 'isTrue',
      label: 'is True',
      getCondition: function getCondition(_ref11) {
        var field = _ref11.field;
        return "eq: { field: \"".concat(field, "\" boolean: true }");
      }
    }, {
      value: 'isFalse',
      label: 'is False',
      getCondition: function getCondition(_ref12) {
        var field = _ref12.field;
        return "eq: { field: \"".concat(field, "\" boolean: false }");
      }
    }]
  };
  result.text = result.string;
  return result;
}();
exports.allConditions = allConditions;
var Condition = function Condition(props) {
  var path = props.path;
  var _props$condition = props.condition,
    column = _props$condition.column,
    operator = _props$condition.operator;
  var type = column ? column.type : '';
  var FilterComponent = allConditions[type] && (allConditions[type].find(function (item) {
    return item.value === operator;
  }) || {}).component;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].condition
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "filter.".concat(path, ".column"),
    render: function render(_ref13) {
      var field = _ref13.field,
        form = _ref13.form;
      var showError = !!(form.errors[field.name] && form.submitCount);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: showError ? 'has-error' : ''
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Select column",
        trigger: /*#__PURE__*/_react["default"].createElement("select", {
          className: "form-control",
          style: {
            width: '12em'
          }
        }, /*#__PURE__*/_react["default"].createElement("option", {
          value: ""
        }, field.value ? field.value.label : '-- Select column --'))
      }, /*#__PURE__*/_react["default"].createElement(_PickColumnForm["default"], {
        onSubmit: function onSubmit(newColumn) {
          var newOperator = operator;
          if (newColumn.type !== type) {
            newOperator = allConditions[newColumn.type][0].value;
          }
          if (newOperator !== operator) {
            form.setFieldValue("filter.".concat(path, ".operator"), newOperator);
          }
          form.setFieldValue("filter.".concat(path, ".column"), (0, _pick2["default"])(newColumn, ['id', 'label', 'type']));
        },
        selectedColumn: column ? column.id : ''
      })), showError && /*#__PURE__*/_react["default"].createElement("div", {
        className: "help-block",
        style: {
          marginBottom: 0
        }
      }, form.errors[field.name]));
    }
  }), column && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "filter.".concat(path, ".operator"),
    render: function render(_ref14) {
      var field = _ref14.field,
        form = _ref14.form;
      var showError = !!(form.errors[field.name] && form.submitCount);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: showError ? 'has-error' : ''
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, field, {
        className: "form-control",
        onChange: function onChange(event) {
          var newOperator = event.target.value;
          if (newOperator) {
            var initialValue = allConditions[type].find(function (item) {
              return item.value === newOperator;
            }).initialValue;
            form.setFieldValue("filter.".concat(path, ".value"), initialValue);
          }
          form.setFieldValue("filter.".concat(path, ".operator"), newOperator);
        },
        style: {
          width: '12em'
        }
      }), (allConditions[type] || []).map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("option", {
          key: item.value,
          value: item.value
        }, item.label);
      })), showError && /*#__PURE__*/_react["default"].createElement("div", {
        className: "help-block",
        style: {
          marginBottom: 0
        }
      }, form.errors[field.name]));
    }
  }), FilterComponent && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(FilterComponent, {
    path: "filter.".concat(path, ".value")
  })));
};
Condition.propTypes = {
  condition: _propTypes["default"].object
};
Condition.defaultProps = {};
var _default = Condition;
exports["default"] = _default;